var map = {
	"./Images": 1813,
	"./Images.jsx": 1813,
	"./banner.jpg": 9311,
	"./contacto.jpeg": 257,
	"./contacto.jpg": 4805,
	"./contacto.png": 5752,
	"./convenios/provenza.jpg": 170,
	"./convenios/spa.jpg": 2031,
	"./galerias/apoyo_empresarial.jpg": 692,
	"./galerias/apoyo_empresarial/202505_taganga/foto_1.jpg": 9382,
	"./galerias/apoyo_empresarial/202505_taganga/foto_2.jpg": 1887,
	"./galerias/apoyo_empresarial/202505_taganga/foto_3.jpg": 7481,
	"./galerias/apoyo_empresarial/202505_taganga/foto_4.jpg": 3618,
	"./galerias/bienestar_social.jpg": 4823,
	"./galerias/bienestar_social/202312_anchetas/foto_1.jpg": 8969,
	"./galerias/bienestar_social/202312_anchetas/foto_2.jpg": 1182,
	"./galerias/bienestar_social/202312_anchetas/foto_3.jpg": 448,
	"./galerias/bienestar_social/202312_anchetas/foto_4.jpg": 2609,
	"./galerias/bienestar_social/202312_anchetas/foto_5.jpg": 8587,
	"./galerias/bienestar_social/202312_anchetas/foto_6.jpg": 1298,
	"./galerias/bienestar_social/20240526_uniformes/foto_1.jpg": 6651,
	"./galerias/bienestar_social/20240526_uniformes/foto_2.jpg": 7636,
	"./galerias/bienestar_social/20240526_uniformes/foto_3.jpg": 5151,
	"./galerias/bienestar_social/20240526_uniformes/foto_4.jpg": 1959,
	"./galerias/bienestar_social/20240526_uniformes/foto_5.jpg": 5359,
	"./galerias/bienestar_social/20240526_uniformes/foto_6.jpg": 8683,
	"./galerias/bienestar_social/20240526_uniformes/foto_7.jpg": 7065,
	"./galerias/bienestar_social/202407_cultura/foto_1.jpg": 8441,
	"./galerias/bienestar_social/202407_cultura/foto_2.jpg": 8306,
	"./galerias/bienestar_social/202407_cultura/foto_3.jpg": 6943,
	"./galerias/bienestar_social/202407_cultura/foto_4.jpg": 4487,
	"./galerias/bienestar_social/202407_cultura/foto_5.jpg": 1463,
	"./galerias/bienestar_social/202412_anchetas/foto_1.jpg": 384,
	"./galerias/bienestar_social/202412_anchetas/foto_2.jpg": 3731,
	"./galerias/bienestar_social/202412_anchetas/foto_3.jpg": 4953,
	"./galerias/bienestar_social/202412_anchetas/foto_4.jpg": 4675,
	"./galerias/bienestar_social/202412_anchetas/foto_5.jpg": 8857,
	"./galerias/capacitaciones.jpg": 7291,
	"./galerias/capacitaciones/2023_economia/foto_1.jpg": 5058,
	"./galerias/capacitaciones/2023_economia/foto_2.jpg": 8895,
	"./galerias/capacitaciones/2023_economia/foto_3.jpg": 2453,
	"./galerias/capacitaciones/2023_economia/foto_4.jpg": 4347,
	"./galerias/capacitaciones/2023_economia/foto_5.jpg": 5244,
	"./galerias/capacitaciones/2023_economia/foto_6.jpg": 3252,
	"./galerias/capacitaciones/2023_economia/foto_7.jpg": 5429,
	"./galerias/capacitaciones/2023_economia/foto_8.jpg": 430,
	"./galerias/capacitaciones/2023_economia/portada.jpg": 3881,
	"./galerias/capacitaciones/2024_salud/foto_1.jpg": 7595,
	"./galerias/capacitaciones/2024_salud/foto_2.jpg": 2091,
	"./galerias/capacitaciones/2024_salud/foto_3.jpg": 2743,
	"./galerias/capacitaciones/2024_salud/foto_4.jpg": 5556,
	"./galerias/capacitaciones/2024_salud/portada.jpg": 5491,
	"./galerias/fortalecimiento_economico.jpg": 7103,
	"./galerias/fortalecimiento_economico/2023_economia/foto_1.jpg": 5693,
	"./galerias/fortalecimiento_economico/2023_economia/foto_2.jpg": 9367,
	"./galerias/fortalecimiento_economico/2023_economia/foto_3.jpg": 1184,
	"./galerias/fortalecimiento_economico/2023_economia/foto_4.jpg": 3696,
	"./galerias/fortalecimiento_economico/2023_economia/foto_5.jpg": 3949,
	"./galerias/fortalecimiento_economico/2023_economia/foto_6.jpg": 9132,
	"./galerias/fortalecimiento_economico/2023_economia/foto_7.jpg": 7034,
	"./galerias/fortalecimiento_economico/2023_economia/foto_8.jpg": 6753,
	"./galerias/fortalecimiento_economico/2023_economia/portada.jpg": 7004,
	"./galerias/gestion_financiera.jpg": 6931,
	"./galerias/gestion_financiera/2025_Pesem/foto_1.jpg": 2890,
	"./galerias/gestion_financiera/2025_Pesem/foto_2.jpg": 5673,
	"./galerias/gestion_financiera/2025_Pesem/foto_3.jpg": 2513,
	"./galerias/gestion_financiera/2025_Pesem/foto_4.jpg": 7566,
	"./galerias/gestion_financiera/2025_Pesem/foto_5.jpg": 7838,
	"./galerias/gestion_financiera/2025_Pesem/foto_6.jpg": 3038,
	"./galerias/gestion_financiera/2025_Pesem/foto_7.jpg": 2758,
	"./galerias/gestion_financiera/2025_Pesem/foto_8.jpg": 1513,
	"./galerias/gestion_financiera/2025_Pesem/portada.jpg": 8079,
	"./logo.png": 533,
	"./logob.png": 5324,
	"./parallax.jpg": 9636,
	"./servicios/adicional.jpg": 7936,
	"./servicios/aporte.jpg": 9186,
	"./servicios/apoyo_empresarial.jpg": 859,
	"./servicios/bienestar_social.jpg": 5890,
	"./servicios/capacitaciones.jpg": 229,
	"./servicios/deporte.jpg": 5195,
	"./servicios/eventos.jpg": 5965,
	"./servicios/fortalecimiento_economico.jpg": 3551,
	"./servicios/gestion_financiera.jpg": 8324,
	"./sliderhome/slider1.fw.png": 7401,
	"./sliderhome/slider1.jpg": 8235,
	"./sliderhome/slider2.fw.png": 2244,
	"./sliderhome/slider2.jpg": 5055,
	"./sliderhome/slider3.fw.png": 222,
	"./sliderhome/slider3.jpg": 9113,
	"./social/202312/01.jpg": 7022,
	"./social/202312/02.jpg": 4384,
	"./social/202312/03.jpg": 519,
	"./social/202312/04.jpg": 5601,
	"./social/202312/05.jpg": 1765,
	"./social/202312/06.jpg": 6162,
	"./social/202412/01.jpg": 4841,
	"./social/202412/02.jpg": 984,
	"./social/202412/03.jpg": 8914,
	"./social/202412/04.jpg": 5551,
	"./social/202412/05.jpg": 4979,
	"./social/202503/01.jpg": 226,
	"./social/202503/02.jpg": 3182,
	"./social/202503/03.jpg": 1058,
	"./social/202503/04.jpg": 9698,
	"./social/202512/1.jpeg": 5007,
	"./social/202512/2.jpeg": 375,
	"./social/202512/3.jpeg": 4405,
	"./social/202512/4.jpeg": 7559,
	"./social/202512/5.jpeg": 5608,
	"./social/202512/6.jpeg": 307,
	"./social/202512/7.jpeg": 8509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3778;